import { MenuItem, TextField } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  setClickActionLocationFixedKeyword,
  setClickActionLocationFixedOffset,
} from "../../redux";
import {
  getClickActionBoxLocationFixedXKeyword,
  getClickActionBoxLocationFixedXOffset,
  getClickActionBoxLocationFixedYKeyword,
  getClickActionBoxLocationFixedYOffset,
  getCurrentHotspot,
} from "../../redux/selectors";
import { numberPattern, numberRegex } from "../../util/general";
import { useStyles } from "../../util/useStyles";

export function ClickActionBoxLocationFixedInput(props) {
  const classes = useStyles();
  const { coordinate = "x" } = props;
  const keywordValue = useSelector((state) =>
    coordinate === "y"
      ? getClickActionBoxLocationFixedYKeyword(state)
      : getClickActionBoxLocationFixedXKeyword(state)
  );
  const offsetValue = useSelector((state) =>
    coordinate === "y"
      ? getClickActionBoxLocationFixedYOffset(state)
      : getClickActionBoxLocationFixedXOffset(state)
  );
  const choices =
    coordinate === "y"
      ? {
          top: "Top",
          center: "Center",
          bottom: "Bottom",
          offset: "Offset in px",
        }
      : {
          left: "Left",
          center: "Center",
          right: "Right",
          offset: "Offset in px",
        };
  const hotspotIndex = useSelector(getCurrentHotspot);
  const dispatch = useDispatch();
  function handleSelection(e) {
    const value = e.target.value;
    dispatch(
      setClickActionLocationFixedKeyword({
        hotspotIndex,
        coordinateName: coordinate,
        keywordValue: value,
      })
    );
  }
  function handleOffsetInput(e) {
    const value = e.target.value === "" ? undefined : e.target.value;
    if (value && !numberRegex.test(e.target.value)) {
      return;
    }
    dispatch(
      setClickActionLocationFixedOffset({
        hotspotIndex,
        coordinateName: coordinate,
        offsetValue: value,
      })
    );
  }
  return (
    <>
      <div>
        <TextField
          select
          fullWidth
          value={keywordValue}
          label={`${coordinate} position`}
          onChange={handleSelection}
          InputProps={{
            classes: {
              input: classes.menuItem,
            },
          }}
        >
          {Object.keys(choices).map((k) => (
            <MenuItem key={k} value={k}>
              {choices[k]}
            </MenuItem>
          ))}
        </TextField>
        <div className="spacer" />
      </div>
      {keywordValue === "offset" && (
        <div>
          <TextField
            inputProps={{ inputMode: "numeric", pattern: numberPattern }}
            InputProps={{
              classes: {
                input: classes.menuItem,
              },
            }}
            onChange={handleOffsetInput}
            value={offsetValue}
          />
        </div>
      )}
    </>
  );
}
